<div>
  <app-details-header
    [type]="(isArchiveAgreement ? 'agr.archival' : 'label.agreement') | locCap"
    [header]="agreement.agreementNumber"
    [icon]="'insert_drive_file'"
    (onEdit)="onEdit()"
    [useEdit]="canEdit"
  >
    <ng-container custom-buttons *ngIf="!isArchiveAgreement && canEdit">
      <a class="archive-button cursor-pointer" (click)="onArchive()">
        <mat-icon color="black" class="font-20">archive</mat-icon> {{ 'button.archive' | loc }}
      </a>
    </ng-container>

    <p *ngIf="agreement">
      <mat-icon class="vertical-align-middle font-18">calendar_today</mat-icon>&nbsp;
      <span class="font-14">
        {{ data.date.from | dateTo: data.date.to:{ toNullValue: ('label.infiniteAgr' | locCap), format: 'dLong' } }}
      </span>
    </p>
    <p>
      <span class="font-14">{{ agreement.bankAccount | iban }}</span>
    </p>
  </app-details-header>

  <div class="page-section">
    <app-details-section headerKey="agr.details">
      <div class="agreement-details">
        <app-labeled-data [label]="'agr.apCount' | loc">
          {{ agreement.tenancyApartmentDetails?.length || 0 }}
        </app-labeled-data>
        <app-labeled-data [label]="'agr.parCount' | loc">
          {{ agreement.tenancyParkingSpotDetails?.length || 0 }}
        </app-labeled-data>
        <app-labeled-data [label]="'agr.stoCount' | loc">
          {{ agreement.tenancyStorageDetails?.length || 0 }}
        </app-labeled-data>

        <app-labeled-data [label]="'agr.deposit' | loc">
          {{ agreement.deposit | currency: agreement.currency }}
        </app-labeled-data>
        <app-labeled-data [label]="'agr.rent' | locCap"> {{ agreement.rent | currency: agreement.currency }} </app-labeled-data>
        <app-labeled-data [label]="'agr.serviceCharge' | loc">
          {{ agreement.serviceCharge | currency: agreement.currency }}
        </app-labeled-data>

        <app-labeled-data [label]="'agr.recipientNo' | loc"> {{ agreement.recipientNumber || '-' }} </app-labeled-data>
      </div>
    </app-details-section>

    <app-details-section
      [headerKey]="'PRSapartment.' + (data.apartments.length > 1 ? 'plural' : 'nominative')"
      *ngIf="data.apartments.length"
    >
      <app-users-rental-units-links [units]="data.apartments" [type]="RentalUnitType.APARTMENT"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section
      *ngIf="data.parkingSpots.length"
      [headerKey]="'parking.' + (data.parkingSpots.length > 1 ? 'plural' : 'nominative')"
    >
      <app-users-rental-units-links [units]="data.parkingSpots" [type]="RentalUnitType.PARKING"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section
      *ngIf="data.storages.length"
      [headerKey]="'storage.' + (data.storages.length > 1 ? 'plural' : 'nominative')"
    >
      <app-users-rental-units-links [units]="data.storages" [type]="RentalUnitType.STORAGE"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section headerKey="agr.residents">
      <app-users-residents-links [residents]="residents"> </app-users-residents-links>
    </app-details-section>

    <app-details-section headerKey="label.attachments" *ngIf="agreement">
      <app-attachment-list-in-view
        *ngIf="agreement.attachments && agreement.attachments.length > 0; else emptyAttachments"
        [attachments]="attachments"
      ></app-attachment-list-in-view>
      <ng-template #emptyAttachments>
        <p class="mat-subheading-2">{{ 'label.noAttachments' | loc }}</p>
      </ng-template>
    </app-details-section>

    <app-details-section headerKey="user.noteList" [last]="true">
      <app-notes [refId]="agreement.id" [type]="NoteType.AGREEMENT" [disableEdit]="!canEdit"></app-notes>
    </app-details-section>
  </div>
</div>
